import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clientOrBuModifiedPipe'
})
export class ClientOrBuModifiedPipe implements PipeTransform {

  transform(clientName: any, isClientGlobalCopy: any): any {
    let output = clientName;
    if (!isClientGlobalCopy) {
      return output + " (Modified)";
    } else {
      return output;
    }
  }

}
